module.exports = __webpack_public_path__ + "img/brand (41).b492b290.png";